import React, { useCallback, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import Button from 'kingpin/atoms/Button';
import Tooltip from 'components/Tooltip';

// A compact copy affordance for a single chat message. Copies the raw message
// text (question text for the user, raw markdown for the assistant) and briefly
// swaps the icon to a checkmark to confirm — mirroring the copy → checkmark
// pattern in kingpin/atoms/CopyText. Uses react-copy-to-clipboard (already a
// project dependency) so no new package is introduced.
const InsightsCopyButton = ({
  text,
  testId,
}: {
  text: string;
  testId?: string;
}) => {
  const [isConfirming, setIsConfirming] = useState<boolean>(false);

  const onCopy = useCallback(() => {
    setIsConfirming(true);
    setTimeout(() => setIsConfirming(false), 2000);
  }, []);

  return (
    <Tooltip content="Copy to clipboard" isFlexAnchor>
      <CopyToClipboard text={text} onCopy={onCopy}>
        <Button
          size="Small"
          type="Ghost"
          icon={isConfirming ? 'checkmark' : 'copy'}
          testId={testId}
        />
      </CopyToClipboard>
    </Tooltip>
  );
};

export default InsightsCopyButton;
